declare namespace $ {

	export class $mol_icon_account_tie extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=tie.view.tree.d.ts.map